import { render, staticRenderFns } from "./testquestion.vue?vue&type=template&id=a5514ea0&scoped=true"
import script from "./testquestion.vue?vue&type=script&lang=ts"
export * from "./testquestion.vue?vue&type=script&lang=ts"
import style0 from "./testquestion.vue?vue&type=style&index=0&id=a5514ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5514ea0",
  null
  
)

export default component.exports